import React from 'react'

const Productmanagement = () => {
  return (
    <div>Productmanagement</div>
  )
}

export default Productmanagement